import { throttle } from 'throttle-debounce';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="block-jump-marks"]';

/**
 * Friendation component
 */
export const blockJumpmarks = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const handleButtons = () => {
      const buttons = Array.from(component.querySelectorAll('.links .button'));

      const onTick = throttle(100, () => {
        buttons.forEach((button) => {
          if (window.innerWidth >= 1280) {
            // desktop
            button.classList.add('button--secondary');
            button.classList.remove('button--tertiary');
          } else {
            // mobile
            button.classList.remove('button--secondary');
            button.classList.add('button--tertiary');
          }
        });
      });

      window.addEventListener('resize', onTick);
      onTick();
    };

    handleButtons();
  });
};
